import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon, Spin, Tag,
} from 'antd';
import Flex from '../../../shared/components/basic/Flex';
import { Text } from '../../../shared/components';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export default function IndicesBar({
  handleChangeIndices,
  indices,
  indicesPreSeleccionados,
  loadingIndices,
  hideColoracion,
}) {
  const drawIndices = ({ indices, keys }) => {
    if (loadingIndices) return <Flex mx={16} alignItems="baseline"><Spin indicator={antIcon} /></Flex>;
    const len = keys.length -1;
    return (keys.map((i, index) => {
      const e = indices[i];
      const indicePreseleccionado = indicesPreSeleccionados[e.id];
      const checked = (indicePreseleccionado) ? indicePreseleccionado.isSelected : e.isSelected;
      return (
        <Tag.CheckableTag
          className="secondary-checkable-tag-checked"
          key={e.id}
          checked={checked}
          onChange={checked => handleChangeIndices(e.id, checked)}
          style={{
            background: 'white', color: 'rgba(0,0,0,0.65)', width: e.id !== -1 ? 44 : 52, textAlign: 'center', marginRight: (index < len || (!hideColoracion)) ? 16 : 0,
          }}
        >
          <Text fontSize={14}>{e.nombre === +e.nombre && e.nombre !== (e.nombre|0) ? e.nombre.toFixed(2) : e.nombre}</Text>
        </Tag.CheckableTag>
      );
    }));
  };
  const keys = Object.keys(indices).sort((a, b) => {
    return indices[a].nombre <= indices[b].nombre ? -1 : 1;
  });
  const labelIndices = keys.length <= 1 ? 'Indice' : 'Indices';
  return (
    <Flex alignItems="baseline">
      <Text mr={16} ml="auto">{`${labelIndices} :`}</Text>
      {drawIndices({ indices, keys })}
    </Flex>
  );
}

IndicesBar.propTypes = {
  handleChangeIndices: PropTypes.func,
  indices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  indicesPreSeleccionados: PropTypes.arrayOf(PropTypes.shape({})),
  loadingIndices: PropTypes.bool,
};
IndicesBar.defaultProps = {
  handleChangeIndices: () => {},
  loadingIndices: false,
  indicesPreSeleccionados:[],
};
